export const SALES_GROUP_REPORT_ID = 'sales-group';
